/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable , BehaviorSubject} from 'rxjs';
import { AppConfig } from '../../app.config';
@Injectable()
export class TagService  {
  tags: any[];
  onTagChanged: BehaviorSubject<any> = new BehaviorSubject({});
  constructor (private http: HttpClient, private api: AppConfig) {

  }
  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
  {

    return new Promise<void>((resolve, reject) => {

      Promise.all([
        this.getTags()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  getTags () {
    return new Promise((resolve, reject) => {
      this.http.get(this.api.baseUrl + '/tag/tags'  , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.tags = response;
          this.onTagChanged.next(this.tags);
          resolve(response);
        }, reject);
    });

  }

  getTagById(id) {
    return this.http.get(this.api.baseUrl + '/tag/tag?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteTag(id) {
    return this.http.delete(this.api.baseUrl + '/tag/deleteTag?id=' + id , this.api.jsonTokenHeaders);
  }

  addTag(data) {
    return this.http.post(this.api.baseUrl + '/tag/addTag' , data , this.api.formDataHeaders);
  }
}
